/**
 * @generated SignedSource<<74761e0b4acfb233791f797bb40c2c6a>>
 * @relayHash 4f20791385a608198c3c70f8004fcf06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID edae287bf0a189b6f61065cc1aa81346178e3cd40deae82f2991be07eb0e059a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareListAppQuery } from './JiraSoftwareListAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareListAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "edae287bf0a189b6f61065cc1aa81346178e3cd40deae82f2991be07eb0e059a",
    "metadata": {},
    "name": "JiraSoftwareListAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
